<template>
	<div id="divUsageCharts" class="col-lg-12" v-show="dollarDataLoaded || consumptionDataLoaded"> 
        <!-- Weather Forecast -->
        <Weather></Weather>

        <!-- Charts -->
        <div id="divChartContainer" class="PayGo_large_top_padding">
            <div class="row">
                <div class="col-md-2 col-sm-2 text-left">&nbsp;</div>
                <div class="col-md-8 col-sm-8 col-xs-12 text-center">
                    <div class="chart-select-options radio-custom div-inline-block" v-for="radioBtn in chartDisplayTypes" v-bind:key="radioBtn.Value">
                        <input type="radio" name="consumption" v-bind:id="radioBtn.Id" v-on:change="getChartDataByUsageType(radioBtn.Value)"
                                                v-model="selectedChartDisplayType" v-bind:value="radioBtn.Value" />
                        <label v-bind:for="radioBtn.Id" class="radio-inline">{{ translateText(radioBtn.Name) }}</label>
                    </div>
                </div>
                <div class="col-md-2 col-sm-2 col-xs-12 text-right">
                    <div id="divChartMenuButtons" class="chart-export-btns">
                        <button id="btnPrintChart" type="button" @click.prevent="printChart" class="btn-icon" title="Print"><v-icon name="print" /></button>
                        <button id="btnExportPdfChart" type="button" @click.prevent="printPdf" class="btn-icon" data-attr="pdf" title="Export PDF"><v-icon name="file-pdf" /></button>
                        <button id="btnExportImageChart" type="button" @click.prevent="printImage" class="btn-icon" data-attr="image" title="Export Image"><v-icon name="file-image" /></button>
                    </div>
                </div>
            </div>

            <div id="divChartButtons" class="row PayGo_medium_top_padding">
                <div class="col-xs-2 text-left btns-left" id="divBtnsLeft">
                    <button id="backTwelve" class="chart-btn" v-if="showBackTwelveBtn" @click.prevent="backTwelveBtnClick()" aria-label="Back"><v-icon name="angle-double-left" /></button>
                    <button id="backOne" class="chart-btn" v-if="showBackOneBtn" @click.prevent="backOneBtnClick()" aria-label="Back One"><v-icon name="angle-left" /></button>
                </div>
                <div class="col-xs-8 text-center" id="divServicePoints"> 
                    <!-- Display Service Type and only if there are multiple SP's for this customer -->
                    <div class="service-points-data" v-if="selectedChartDisplayType == 1">
                        <p class="div-inline-block">{{ $tc("message.servicePoints", servicePoints.length) }}: </p>
                        <a v-for="servicePoint in servicePoints" :key="servicePoint.PremiseID" href="#" @click.prevent="getChartDataByServicePoint(servicePoint.PremiseID)" 
                                    class="servicepoint-link" :class="{ selected: servicePointId === servicePoint.PremiseID }">{{ servicePoint.PremiseName }}</a>
                    </div>
                </div>
                <div class="col-xs-2 text-right btns-right" id="divBtnsRight">
                    <button id="forwardOne" class="chart-btn" v-if="showForwardOneBtn" @click.prevent="forwardOneBtnClick()" aria-label="Forward"><v-icon name="angle-right" /></button>
                    <button id="forwardTwelve" class="chart-btn" v-if="showForwardTwelveBtn" @click.prevent="forwardTwelveBtnClick()" aria-label="Forward One"><v-icon name="angle-double-right" /></button>
                </div>
            </div>

            <div id="divChartsSection" class="row PayGo_medium_top_padding">
                <div id="divNoDataMessage" class="text-center custom-margin-top" v-if="displayNoDataMessageForConsumption">
                    <label class="alert-text">{{ $t("message.noDataAvailable") }}</label>
                </div>
                
                <!-- Dollar Chart -->
                <div v-show="selectedChartDisplayType === 2">
                    <highcharts class="chart" :options="chartOptions" ref="highchartsChart"></highcharts> 
                </div>                

                <!-- Consumption Chart -->
                <div :class="displayDollarChart">
                    <highcharts class="chart" :options="consumptionChartOptions" ref="highchartsConsumptionChart"></highcharts>  
                </div>                                   

                <div class="text-center" v-show="displayChartFooterMessage">
                    <p class="font-size-sm">{{ $t("message.usageChartsFooterMessage") }}</p>
                </div>

                <div class="text-center padding-left-right-custom">
                    <button id="backToMonthly" v-if="showBackToMonthly" class="btn btn-primary" @click.prevent="backToMonthlyClick()">{{ $t("message.backToMonthly") }}</button>
                    <button id="backToDaily" v-if="showBackToDaily" class="btn btn-primary" @click.prevent="backToDailyClick()">{{ $t("message.backToDaily") }}</button>
                </div>
            </div>

            <div class="row PayGo_medium_top_padding text-center" v-show="showForecastData && selectedChartDisplayType === 2">
                <button id="btnSetDailyGoal" class="btn btn-primary" @click.prevent="showModal()">{{ $t("message.setDailyGoal") }}</button>
            </div>
        </div>

        <modal v-show="isModalVisible" @close="closeModal">
            <h4 class="modal-title" slot="header">{{ $t("message.setDailyGoal") }}</h4>
            <div slot="body">
                <form @submit.prevent="saveDailyDollarGoal(false)">
                    <div id="divDailyGoal">
                        <div class="row">
                            <div class="col-lg-12">
                                <label for="txtDailyGoal"><b>{{ $t("message.enterDailyGoal") }}:</b></label>
                                <vue-numeric currency="$" separator="," v-model="dailyGoal" :minus="false" :precision="2" class="form-control form-control-sm" id="txtDailyGoal"></vue-numeric>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div slot="footer">
                <button id="btnRemoveDailyDollarGoal" class="btn btn-primary float-left" :disabled="isRemoveDailyGoalBtnDisabled" @click="saveDailyDollarGoal(true)">{{ $t("message.removeDailyGoal") }}</button>

                <button id="btnSaveDailyDollarGoal" class="btn btn-primary" :disabled="isSaveDailyDollarGoalBtnDisabled" @click="saveDailyDollarGoal(false)">{{ $t("message.add") }}</button>
                <button id="btnCancel" class="btn btn-cancel" @click="closeModal()">{{ $t("message.cancel") }}</button>              
            </div>
        </modal>
    </div>
</template>

<script>
import axios from "axios";
import chartHelper from '@/assets/js/chartHelper';
import Weather from '@/components/dashboard/Weather';
import Modal from '@/components/common/Modal';
import VueNumeric from 'vue-numeric';

export default {
    name: 'UsageCharts',
    components: {
        Weather,
        Modal,
        VueNumeric
    },
    data() {
        return {
            chartOptions: [],
            consumptionChartOptions: [],
            servicePoints: [],
            servicePointId: -1,
            currentChart: chartHelper.ChartType.Monthly,
            currentConsumptionType: chartHelper.ChartConsumptionType.Dollar,
            minimumAvailableDollarDate: new Date(),
            maximumAvailableDollarDate: new Date(),
            minimumAvailableDate: new Date(),
            maximumAvailableDate: new Date(),
            overallMaxDate: new Date(),
            overallMinDate: new Date(),
            numberOfMonths: 14,
            isDesktop: true,
            year: null,
            month: null,
            day: null,
            numOfDays: null,
            previousDay: null,
            showBackOneBtn: false,
            showBackTwelveBtn: false,
            showForwardOneBtn: false,
            showForwardTwelveBtn: false,
            showBackToMonthly: false,
            showBackToDaily: false,
            selectedChartDisplayType: 2,
            chartDisplayTypes: [
                { Id: "rdoDollars", Value: 2, Name: "Dollars" },
                { Id: "rdoConsumption", Value: 1, Name: "Consumption" }
            ],
            windowWidth: 0,
            originalWindowWidth: window.innerWidth,
            showNoDataAvailableMessage: false,
            consumptionStartDate: null,
            consumptionEndDate: null,
            dollarDataLoaded: false,
            consumptionDataLoaded: false,
            dailyGoal: 0,
            isModalVisible: false,
            isRemoveDailyGoalBtnDisabled: true,
            showForecastData: false
        }
    },
    mounted() {
        this.getDollarChartData();
    },
    methods: {        
        handleWindowResize(event) {
            this.windowWidth = window.innerWidth;
            this.isDesktop = this.windowWidth > 768;

            if (this.originalWindowWidth !== this.windowWidth) {
                // Reload chart data only if our window width has changed
                this.reloadChartData();
                this.originalWindowWidth = this.windowWidth;
            }          
        },
        reloadChartData() {
            if (this.selectedChartDisplayType === chartHelper.ChartConsumptionType.Dollar) {
                this.hideMonthlyAndDailyBtns();
                this.removeDailyGoalPlotLine();               
                this.getDollarChartData();
            } else {
                this.getConsumptionChartData();
            }
        },
        getDollarChartData() {
            this.currentChart = chartHelper.ChartType.Monthly;
            this.currentConsumptionType = chartHelper.ChartConsumptionType.Dollar;

            if (this.currentChart === chartHelper.ChartType.Monthly && this.currentConsumptionType === chartHelper.ChartConsumptionType.Dollar) {
                if (this.isDesktop) {
                    // do not display back and forward btns when in Dollar/Monthly view
                    this.hideBackAndForwardOneBtns();
                } else {
                    // mobile: display back and forward buttons to allow user to go back and forward by a month
                    this.showLeftRightBtns();
                    this.hideBackAndForwardTwelveBtns();
                }                
            }

            this.getDollarData(this.currentConsumptionType, this.currentChart, this.servicePointId, null, null, null, null, this.isDesktop);
        },
        onMonthlyDollarClick(e) {
            if (this.disableClickForForecastSeries(e)) {
                var category = e.point.category;
                this.year = category.substring(category.length - 4);
                this.month = chartHelper.getMonth(category.substring(0, 4).trim(), this.year);

                if (this.isDesktop) {
                    this.showDailyDollarChart(this.month, this.year, null, null);
                    this.showLeftRightBtns();
                    this.hideBackAndForwardOneBtns();
                } else {
                    this.day = new Date(this.year, this.month - 1, 1);
                    this.showDailyDollarChart(this.month, this.year, this.day.getDate(), 4);
                    this.showBackAndForwardOneBtns();
                }

                this.showBackToMonthly = true;
            } else {
                return false;
            }            
        },
        onDailyDollarClick(e) {
            if (this.disableClickForForecastSeries(e)) {
                var category = e.point.category;
                var selectedDate = category.split('/');
                this.month = selectedDate[0];
                this.day = selectedDate[1];
                this.year = selectedDate[2];

                this.showHourlyDollarChart(this.month, this.day, this.year);
                this.removeDailyGoalPlotLine();
                this.showBackToMonthly = false;
                this.showBackToDaily = true;
                this.hideLeftRightBtns();
            } else {
                return false;
            }            
        },
        getSeriesName(e) {
            return e.point.series.name;
        },
        disableClickForForecastSeries(e) {
            var seriesName = this.getSeriesName(e);
            if (seriesName.trim().toLowerCase() === "forecast") {
                return false;
            } else {
                return true;
            }
        },
        showDailyDollarChart(month, year, day, numOfDays) {
            this.currentChart = chartHelper.ChartType.Daily;
            this.currentConsumptionType = chartHelper.ChartConsumptionType.Dollar;

            this.getDollarData(this.currentConsumptionType, this.currentChart, this.servicePointId, year, month, day, numOfDays, this.isDesktop);
        },
        showHourlyDollarChart(month, day, year) {
            this.currentChart = chartHelper.ChartType.Hourly;
            this.currentConsumptionType = chartHelper.ChartConsumptionType.Dollar;

            this.getDollarData(this.currentConsumptionType, this.currentChart, this.servicePointId, year, month, day, null, this.isDesktop);
        },
        getDollarData(usage, chartType, spId, y, m, d, numOfDays, isDesktop) {
            axios({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "Usage/GetDollarChartData",
                data: {
                    usageType: usage,
                    chartType: chartType,
                    servicePointId: spId,
                    year: y,
                    month: m,
                    day: d,
                    numOfDays: numOfDays, 
                    isDesktop: isDesktop,
                    previousDay: this.previousDay
                }
            }).then(result => {
                var response = result.data;
                if (response === 404) { // Error
                    this.$router.push({ name: 'Error' });
                } else if (response !== '') { // Success, we received data back from our POST
                    this.previousDay = d;
                    this.setupDollarChartData(response);                    
                }
            }, error => {
                this.showError("Error loading Dollar chart data");
            })
        },
        setupDollarChartData(data) {
            var categoriesData = data.Categories;
            var stackedSeriesData = data.ServiceData;
            var chartHeadingText = data.ChartHeadingText;
            var clickText = data.PointClickText;
            var yAxisText = this.translateText("Dollars");
            var weatherOverlay = data.EnableWeatherOverlay;
            var yPrimaryAxisTitle = !weatherOverlay ? '' : this.translateText("Temperature");
            var dailyGoal = data.DailyGoal;
            this.showForecastData = data.ShowForecastData;

            // Get min and max dates, replace '-' and 'T.+' to get accurate dates
            if (categoriesData.length > 0) {
                var sortedDateData = categoriesData.sort(chartHelper.sortCategoriesData);
                var minDate = new Date(sortedDateData[0].replace(/-/g, '\/').replace(/T.+/, ''));
                var maxDate = new Date(sortedDateData[sortedDateData.length - 1].replace(/-/g, '\/').replace(/T.+/, ''));
                maxDate = new Date(maxDate.getFullYear(), maxDate.getMonth() + 1, 0); // Get the last day for this month

                // Responsive: Daily Dollar chart update the overall max date if the max date is greater 
                // It will give us the last date we have data for
                if (!this.isDesktop && this.currentChart === chartHelper.ChartType.Daily && maxDate > this.overallMaxDate) {
                    this.overallMaxDate = maxDate;
                }

                if (this.currentChart === chartHelper.ChartType.Monthly && this.currentConsumptionType === chartHelper.ChartConsumptionType.Dollar) {
                    // Get previous month as minimum 
                    this.minimumAvailableDollarDate = chartHelper.addMonths(minDate, -1);
                    this.maximumAvailableDollarDate = new Date(maxDate.getFullYear(), maxDate.getMonth() + 1, 0);

                    // We are going to send the Max and Min dates on the first AJAX request for dollar chart data
                    // Lets save it here, we will use it later to show/hide the left/right arrows
                    if (data.MinDollarDate != null && data.MaxDollarDate != null) {
                        this.overallMinDate = new Date(data.MinDollarDate);
                        this.overallMaxDate = new Date(data.MaxDollarDate);
                    }
                }

                if (!this.isDesktop && this.currentChart === chartHelper.ChartType.Daily && maxDate.getTime() === this.overallMaxDate.getTime()) {
                    maxDate.setDate(maxDate.getDate() - 1);
                }

                // Using the calculated min/max dates and the overall min/max dates figure out if we need to show back and forward buttons
                if (this.currentChart === chartHelper.ChartType.Monthly || this.currentChart === chartHelper.ChartType.Daily) {
                    if (this.isDesktop) {
                        this.showBackTwelveBtn = minDate > this.overallMinDate;
                        this.showForwardTwelveBtn = maxDate < this.overallMaxDate;
                    } else {
                        this.showBackOneBtn = minDate > this.overallMinDate;                        
                        this.showForwardOneBtn = maxDate < this.overallMaxDate;
                    }
                }
            }

            var options = '';

            if (this.currentChart === chartHelper.ChartType.Monthly) {
                categoriesData = chartHelper.formatDateArray(categoriesData);

                options = chartHelper.getDollarChartOptions(chartHeadingText, this.currentChart, this.onMonthlyDollarClick, categoriesData, stackedSeriesData, 
                                                                clickText, yAxisText, yPrimaryAxisTitle);

            } else if (this.currentChart === chartHelper.ChartType.Daily) {
                categoriesData = chartHelper.formatToDisplayDates(categoriesData);

                if (clickText === "") {
                    // If hourly drilldown setting is not enabled
                    options = chartHelper.getDollarChartOptions(chartHeadingText, this.currentChart, '', categoriesData, stackedSeriesData, clickText, yAxisText, yPrimaryAxisTitle);
                } else {
                    options = chartHelper.getDollarChartOptions(chartHeadingText, this.currentChart, this.onDailyDollarClick, categoriesData, stackedSeriesData, clickText, yAxisText, yPrimaryAxisTitle);
                } 

            } else if (this.currentChart === chartHelper.ChartType.Hourly) {
                categoriesData = chartHelper.formatToDisplayHours(categoriesData);

                // hourly data will not have click function as its the last step of the drill-down
                options = chartHelper.getDollarChartOptions(chartHeadingText, this.currentChart, '', categoriesData, stackedSeriesData, clickText, yAxisText, yPrimaryAxisTitle);

            }

            this.chartOptions = options;
            this.dollarDataLoaded = true;

            // Only add the new PlotLine to show 'Daily Goal' when viewing Daily Dollar chart
            if (dailyGoal !== 0 && this.currentChart === chartHelper.ChartType.Daily) {
                this.$refs.highchartsChart.chart.yAxis[1].addPlotLine({
                    value: dailyGoal,
                    color: '#1473b3',
                    dashStyle: 'shortdash',
                    width: 2,
                    id: 'dailygoal-plotline',
                    zIndex: 5,
                    label: {
                        text: 'Daily Goal: $' + dailyGoal.toFixed(2),
                        align: 'right',
                        style: {
                            fontWeight: 'bold'
                        }
                    }
                });
            }           
        },
        getChartDataByUsageType(val) {
            this.selectedChartDisplayType = val;
            this.currentConsumptionType = val;
            this.currentChart = chartHelper.ChartType.Monthly;
            this.year = null;
            this.month = null;
            this.day = null;

            this.hideMonthlyAndDailyBtns();

            if (this.currentConsumptionType === chartHelper.ChartConsumptionType.Dollar) {
                this.getDollarChartData();
                this.removeDailyGoalPlotLine();
            } else {
                this.showBackAndForwardOneBtns();
                this.showBackAndForwardTwelveBtns();
                this.getConsumptionChartData();
            }
        },
        getChartDataByServicePoint(spId) {
            this.servicePointId = spId;
            this.currentConsumptionType = chartHelper.ChartConsumptionType.Consumption;
            this.hideBackAndForwardOneBtns();
            
            this.getConsumptionChartData();
        },
        printChart() {
            if (this.currentConsumptionType === chartHelper.ChartConsumptionType.Dollar) {
                this.$refs.highchartsChart.chart.print();
            } else {
                this.$refs.highchartsConsumptionChart.chart.print();
            }            
        },
        printPdf() {
            if (this.currentConsumptionType === chartHelper.ChartConsumptionType.Dollar) {
                this.$refs.highchartsChart.chart.exportChart({ type: "application/pdf" });
            } else {
                this.$refs.highchartsConsumptionChart.chart.exportChart({ type: "application/pdf" });
            }
        },
        printImage() {
            if (this.currentConsumptionType === chartHelper.ChartConsumptionType.Dollar) {
                this.$refs.highchartsChart.chart.exportChart({ type: "image/jpeg" });
            } else {
                this.$refs.highchartsConsumptionChart.chart.exportChart({ type: "image/jpeg" });
            }
        },        
        backTwelveBtnClick() {
            if (this.currentChart === chartHelper.ChartType.Daily) {
                if (this.isDesktop) {
                    this.moveMonths(-1); // move back one month
                } else {
                    this.moveMonths(-4); // mobile: move back four days
                }
            } else {
                this.moveMonths(-12);
            }
        },
        backOneBtnClick() {
            if (this.currentChart === chartHelper.ChartType.Daily) {
                this.isDesktop ? this.moveDays(-1) : this.moveDays(-4);
            } else {
                this.isDesktop ? this.moveMonths(-1) : this.moveMonths(-4);
            }
        },
        forwardTwelveBtnClick() {
            if (this.currentChart === chartHelper.ChartType.Daily) {
                this.isDesktop ? this.moveMonths(1) : this.moveDays(4);
            } else {
                this.moveMonths(12);
            }
        },
        forwardOneBtnClick() {
            if (this.currentChart === chartHelper.ChartType.Daily) {
                this.isDesktop ? this.moveDays(1) : this.moveDays(4);              
            } else {
                this.isDesktop ? this.moveMonths(1) : this.moveMonths(4);
            }
        },
        moveDays(val) {
            var currentMin;
            var currentMax;
            var chart;

            if (this.currentConsumptionType === chartHelper.ChartConsumptionType.Dollar) {
                chart = this.$refs.highchartsChart.chart;

                var categoriesLength = chart.xAxis[0].categories.length;
                currentMin = new Date(chart.xAxis[0].categories[0]);
                currentMax = new Date(chart.xAxis[0].categories[categoriesLength - 1]);

            } else {
                chart = this.$refs.highchartsConsumptionChart.chart;

                currentMin = new Date(chart.xAxis[0].getExtremes().min);
                currentMax = new Date(chart.xAxis[0].getExtremes().max);

            }

            var newMin = chartHelper.addDays(currentMin, val);
            var newMax = chartHelper.addDays(currentMax, val);

            if (this.currentConsumptionType === chartHelper.ChartConsumptionType.Consumption) { // Consumption chart
                if (this.currentChart === chartHelper.ChartType.Monthly) {
                    if (newMax > this.maximumAvailableDate) {
                        newMax = this.maximumAvailableDate;
                        newMin = currentMin;
                    }
                    chart.xAxis[0].setExtremes(newMin.getTime(), newMax.getTime());

                } else if (this.currentChart === chartHelper.ChartType.Daily) {
                    // Set Start and End date values and fetch Consumption data
                    this.consumptionStartDate = newMin;
                    this.consumptionEndDate = newMax;
                    this.getConsumptionChartData();
                }

            } else if (this.currentConsumptionType === chartHelper.ChartConsumptionType.Dollar) { // Dollar chart
                if (val < 0) {
                    this.showDailyDollarChart(newMax.getMonth() + 1, newMax.getFullYear(), newMax.getDate(), val);
                } else {
                    this.showDailyDollarChart(newMin.getMonth() + 1, newMin.getFullYear(), newMin.getDate(), val);
                }
            }
        },
        moveMonths(val) {
            var currentMin;
            var currentMax;
            var newMin;
            var newMax;
            var chart;
            
            if (this.currentConsumptionType === chartHelper.ChartConsumptionType.Dollar) {
                chart = this.$refs.highchartsChart.chart;

                var categoriesLength = chart.xAxis[0].categories.length;
                currentMin = new Date(chart.xAxis[0].categories[0]);
                currentMax = new Date(chart.xAxis[0].categories[categoriesLength - 1]);

            } else {
                chart = this.$refs.highchartsConsumptionChart.chart;

                currentMin = new Date(chart.xAxis[0].getExtremes().min);
                currentMax = new Date(chart.xAxis[0].getExtremes().max);
            }

            newMin = chartHelper.addMonths(currentMin, val);
            newMax = chartHelper.addMonths(currentMax, val);

            if (this.currentConsumptionType === chartHelper.ChartConsumptionType.Consumption) { // Consumption
                this.resetStartAndEndDates();
                if (newMax > this.overallMaxDate) {
                    newMax = currentMax;
                    newMin = currentMin;
                }

                if (this.currentChart === chartHelper.ChartType.Monthly) {
                    this.numberOfMonths = 14;
                    var monthsBetween = (this.minimumAvailableDate.getMonth() - newMin.getMonth()) + (12 * (this.minimumAvailableDate.getFullYear() - newMin.getFullYear()))
                    if (monthsBetween > (this.numberOfMonths - 2)) {
                        newMin = currentMin;
                        newMax = currentMax;
                    }
                } else if (this.currentChart === chartHelper.ChartType.Daily) {
                    if (newMin < this.overallMinDate) {
                        newMin = currentMin;
                        newMax = currentMax;
                    } else {
                        var endDate = newMax;
                        this.month = endDate.getMonth() + 1;
                        this.year = endDate.getFullYear();
                        this.day = null;
                        this.showDailyConsumptionChart(this.month, this.year);

                        this.showBackToMonthly = true;
                    }
                }

                chart.xAxis[0].setExtremes(newMin.getTime(), newMax.getTime());

            } else if (this.currentConsumptionType === chartHelper.ChartConsumptionType.Dollar) { // Dollar
                this.month = newMax.getMonth() + 1;
                this.year = newMax.getFullYear();

                if (this.currentChart === chartHelper.ChartType.Daily) {
                    if (newMin >= this.overallMinDate && newMin < this.maximumAvailableDollarDate) {
                        // load data, so we can get new categories (xaxis) and its associated consumption data
                        this.showDailyDollarChart(this.month, this.year, null, null);
                    }
                } else if (this.currentChart === chartHelper.ChartType.Monthly) {
                    // Dollar Monthly chart - based on the value passed in get the min and max
                    var calculatedMonth;
                    var calculatedYear;
                    if (val < 0) {
                        calculatedMonth = (currentMin.getMonth() + 1) * -1;
                        calculatedYear = currentMin.getFullYear();
                    } else {
                        calculatedMonth = currentMax.getMonth() + 1;
                        calculatedYear = currentMax.getFullYear();
                    }

                    this.getDollarData(chartHelper.ChartConsumptionType.Dollar, chartHelper.ChartType.Monthly, this.servicePointId, calculatedYear, calculatedMonth, null, null, this.isDesktop);
                }
            }
        },
        hideBackAndForwardOneBtns() {
            this.showBackOneBtn = false;
            this.showForwardOneBtn = false;          
        },
        showBackAndForwardOneBtns() {
            this.showBackOneBtn = true;
            this.showForwardOneBtn = true;
        },
        hideBackAndForwardTwelveBtns() {
            this.showBackTwelveBtn = false;
            this.showForwardTwelveBtn = false;
        },
        showBackAndForwardTwelveBtns() {
            this.showBackTwelveBtn = true;
            this.showForwardTwelveBtn = true;
        },
        hideLeftRightBtns() {
            this.hideBackAndForwardOneBtns();
            this.hideBackAndForwardTwelveBtns();
        },
        showLeftRightBtns() {
            this.showBackAndForwardOneBtns();
            this.showBackAndForwardTwelveBtns();
        },
        backToMonthlyClick() {
            this.currentChart = chartHelper.ChartType.Monthly;
            this.year = null;
            this.month = null;
            this.day = null;
            this.showBackToMonthly = false;

            if (this.currentConsumptionType === chartHelper.ChartConsumptionType.Dollar) {
                this.getDollarChartData();
                this.removeDailyGoalPlotLine();
            } else {
                this.hideLeftRightBtns();
                this.getConsumptionChartData();
            }            
        },
        backToDailyClick() {
            this.showLeftRightBtns();

            if (this.currentConsumptionType === chartHelper.ChartConsumptionType.Dollar) {
                if (this.isDesktop) {
                    this.day = null;
                    this.numOfDays = null;

                    this.showDailyDollarChart(this.month, this.year, this.day, this.numOfDays);
                    this.hideBackAndForwardOneBtns();
                } else {
                    var calculatedDate = new Date(this.year, this.month - 1, 1);
                    this.day = calculatedDate.getDate(), this.numOfDays = 4;
                    this.showDailyDollarChart(this.month, this.year, this.day, this.numOfDays);

                    this.hideBackAndForwardTwelveBtns();
                }
            } else {
                this.day = null;
                this.showDailyConsumptionChart(this.month, this.year);
            }

            this.showBackToDaily = false;
            this.showBackToMonthly = true;
        },
        removeDailyGoalPlotLine() {
            // We will have to remove the PlotLine for Daily Goal that was added when we viewed Daily Dollar Chart
            // Remove only if we are displaying forecast data
            if (this.showForecastData) {
                var dollarChart = this.$refs.highchartsChart.chart;            
                if (dollarChart !== undefined) {
                    var yAxis = dollarChart.yAxis[1];
                    yAxis.removePlotLine('dailygoal-plotline');
                }
            }                                   
        },
        resetStartAndEndDates() {
            this.consumptionStartDate = null;
            this.consumptionEndDate = null;
        },
        getConsumptionChartData() {            
            // Update show/hide status for all the back/forward buttons
            if (this.currentChart === chartHelper.ChartType.Monthly) {
                this.hideMonthlyAndDailyBtns();
                this.resetStartAndEndDates();
            } else if (this.currentChart === chartHelper.ChartType.Daily) {
                this.showBackToMonthly = true;
            } else {
                this.hideLeftRightBtns();
                this.resetStartAndEndDates();
                this.showBackToDaily = true;
            }  
            
            this.getConsumptionData(this.currentConsumptionType, this.currentChart, this.servicePointId, this.year, this.month, this.day, this.isDesktop, this.consumptionStartDate, this.consumptionEndDate);
        },
        getConsumptionData(usage, chartType, spId, y, m, d, isDesktop, sd, ed) {
            if (!isDesktop) {
                if (chartType === chartHelper.ChartType.Monthly) {
                    this.numberOfMonths = 4;
                }
            } else {
                this.numberOfMonths = 14;
            }

            axios({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "Usage/GetConsumptionChartData",
                data: {
                    usageType: usage,
                    chartType: chartType,
                    servicePointId: spId,
                    year: y,
                    month: m, 
                    day: d,
                    isDesktop: isDesktop,
                    startDate: sd,
                    endDate: ed
                }
            }).then(result => {
                var response = result.data;
                if (response === 404) { // Error
                    this.$router.push({ name: 'Error' });
                } else if (response !== '') { // Success, we received data back from our POST
                    this.setupConsumptionChartData(response);
                }
            }, error => {
                this.showError("Error loading consumption data");
            })

            this.showHideBackAndForwardTwelveBtnsForConsumptionChart();
        },
        setupConsumptionChartData(data) {
            var parsedData = this.processConsumptionData(data);
            var consumptionData = parsedData[0];

            if (consumptionData.length) {
                this.showNoDataAvailableMessage = false;

                var highTempData = parsedData[1];
                var lowTempData = parsedData[2];
                var chartColor = parsedData[3];
                var dollarPrefix = parsedData[4];
                var consumptionSuffix = parsedData[5];
                var moreDetails = parsedData[6];
                var cursorInfo = parsedData[7];
                var titleText = parsedData[8];
                var weatherOverlay = parsedData[10];

                var yAxisName = 'Consumption ' + ' (' + consumptionSuffix + ')';
                var yAxisPrimaryTitle = 'Temperature';
                var highTempTitle = 'High Temperature';
                var lowTempTitle = 'Low Temperature';

                if (!weatherOverlay) {
                    yAxisPrimaryTitle = '';
                    highTempTitle = '';
                    lowTempTitle = '';
                }

                var options;
                var chart = this.$refs.highchartsConsumptionChart.chart;

                if (this.currentChart === chartHelper.ChartType.Monthly) {
                    options = chartHelper.getChartOptions(titleText, this.currentChart, this.onMonthlyConsumptionClick, consumptionData, highTempData, lowTempData, this.minimumAvailableDate.getTime(), this.maximumAvailableDate.getTime(), cursorInfo, yAxisPrimaryTitle, yAxisName, chartColor,
                                            dollarPrefix, consumptionSuffix, moreDetails, highTempTitle, lowTempTitle, weatherOverlay);

                    this.consumptionChartOptions = options;
                    this.goToEnd();

                } else if (this.currentChart === chartHelper.ChartType.Daily) {
                    if (moreDetails === "") {
                        // If hourly drilldown setting is not enabled
                        options = chartHelper.getChartOptions(titleText, this.currentChart, '', consumptionData, highTempData, lowTempData, this.minimumAvailableDate.getTime(), this.maximumAvailableDate.getTime(), cursorInfo, yAxisPrimaryTitle, yAxisName, chartColor,
                                            dollarPrefix, consumptionSuffix, moreDetails, highTempTitle, lowTempTitle, weatherOverlay);
                    } else {
                        options = chartHelper.getChartOptions(titleText, this.currentChart, this.onDailyConsumptionClick, consumptionData, highTempData, lowTempData, this.minimumAvailableDate.getTime(), this.maximumAvailableDate.getTime(), cursorInfo, yAxisPrimaryTitle, yAxisName, chartColor,
                                            dollarPrefix, consumptionSuffix, moreDetails, highTempTitle, lowTempTitle, weatherOverlay);
                    }

                    this.consumptionChartOptions = options;
                    chart.xAxis[0].setExtremes(this.minimumAvailableDate.getTime(), this.maximumAvailableDate.getTime());

                } else if (this.currentChart === chartHelper.ChartType.Hourly) {
                    options = chartHelper.getChartOptions(titleText, this.currentChart, '', consumptionData, highTempData, lowTempData, this.minimumAvailableDate.getTime(), this.maximumAvailableDate.getTime(), cursorInfo, yAxisPrimaryTitle, yAxisName, chartColor,
                                            dollarPrefix, consumptionSuffix, moreDetails, highTempTitle, lowTempTitle, weatherOverlay);
                    
                    this.consumptionChartOptions = options;
                    chart.xAxis[0].setExtremes(this.minimumAvailableDate.getTime(), this.maximumAvailableDate.getTime());       
                }

                // Get the current min/max from the chart
                var currentMin = new Date(chart.xAxis[0].getExtremes().userMin);
                var currentMax = new Date(chart.xAxis[0].getExtremes().userMax);

                if (this.currentChart === chartHelper.ChartType.Monthly || this.currentChart === chartHelper.ChartType.Daily) {
                    if (this.isDesktop) {
                        this.showBackOneBtn = currentMin >= this.overallMinDate;
                        this.showForwardOneBtn = currentMax < this.overallMaxDate;

                        this.showBackTwelveBtn = currentMin >= this.overallMinDate;
                        this.showForwardTwelveBtn = currentMax < this.overallMaxDate;
                    } else {
                        this.showBackOneBtn = currentMin > this.overallMinDate;
                        this.showForwardOneBtn = currentMax < this.overallMaxDate;
                    }
                } 

                this.servicePointId = parsedData[9];
                this.consumptionDataLoaded = true;
            } else {
                this.hideBackAndForwardOneBtns();
                this.showNoDataAvailableMessage = true;
            }
        },
        processConsumptionData(data) {
            var receivedData = data;
            this.servicePoints = receivedData.ServicePoints;
            var consumptionWeatherOverlay = receivedData.EnableWeatherOverlay;
            var consumptionData = [];
            var highTempData = [];
            var lowTempData = [];
            var dates = [];

            for (var i = 0; i <= receivedData.ChartDataList.length; i++) {
                if (receivedData.ChartDataList[i]) {
                    consumptionData.push([new Date(receivedData.ChartDataList[i].ReadDate).getTime(), receivedData.ChartDataList[i].ChartValue]);
                    if (consumptionWeatherOverlay) {
                        // fetch data only if weather overlay is enabled
                        highTempData.push([new Date(receivedData.ChartDataList[i].ReadDate).getTime(), receivedData.ChartDataList[i].HighTemp]);
                        lowTempData.push([new Date(receivedData.ChartDataList[i].ReadDate).getTime(), receivedData.ChartDataList[i].LowTemp]);
                    }

                    dates.push(receivedData.ChartDataList[i].ReadDate);
                }
            }

            // get min and max dates
            var sortedDateData = dates.sort(chartHelper.sortCategoriesData);
            var minDate = sortedDateData[0];
            var maxDate = sortedDateData[sortedDateData.length - 1];

            if (minDate != null && maxDate != null) {
                minDate = new Date(minDate.replace(/-/g, '\/').replace(/T.+/, '')); //replace '-' and 'T.+' to get accurate date
                maxDate = new Date(maxDate.replace(/-/g, '\/').replace(/T.+/, ''));

                if (this.currentChart === chartHelper.ChartType.Monthly) {
                    this.overallMinDate = minDate;
                    this.overallMaxDate = new Date(maxDate.getFullYear(), maxDate.getMonth() + 1, 0); // Get last day for this month

                }
                else if (this.currentChart === chartHelper.ChartType.Daily) {
                    if (!this.isDesktop) {
                        maxDate = new Date(minDate);
                        maxDate.setDate(maxDate.getDate() + 3);
                    }

                }
                else if (this.currentChart === chartHelper.ChartType.Hourly) {
                    // Set the hourly data (Consumption) to start from 1:00 to 00:00 (since midnight read is actually consumption from previous day)
                    minDate = new Date(minDate.setHours(1));
                    
                }

                this.minimumAvailableDate = minDate;
                this.maximumAvailableDate = maxDate;           
            }

            return [consumptionData, highTempData, lowTempData, receivedData.ChartColor, receivedData.DollarPrefix, receivedData.ConsumptionSuffix, receivedData.MoreDetails, 
                    receivedData.Cursor, receivedData.ChartHeadingText, receivedData.SelectedServicePointId, consumptionWeatherOverlay];

        },
        onMonthlyConsumptionClick(e) {
            var pointDate = new Date(e.point.x);
            var startDate = pointDate;
            var endDate = new Date();

            if (!this.isDesktop) {
                endDate = new Date(startDate);
                endDate.setDate(endDate.getDate() + 3);
            } else {
                endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
            }

            this.minimumAvailableDate = startDate;
            this.maximumAvailableDate = endDate;

            this.month = endDate.getMonth() + 1;
            this.year = endDate.getFullYear();

            this.showDailyConsumptionChart(this.month, this.year);
            this.showBackAndForwardOneBtns();
            this.showBackToMonthly = true;
        },
        onDailyConsumptionClick(e) {
            var pointDate = new Date(e.point.x);
            this.day = pointDate.getDate();
            this.month = pointDate.getMonth() + 1;
            this.year = pointDate.getFullYear();

            this.minimumAvailableDate = pointDate.setHours(0, 0, 0, 0);
            this.maximumAvailableDate = pointDate.setHours(23, 59, 59, 999);

            this.showHourlyConsumptionChart(this.month, this.year, this.day);
            this.showBackToMonthly = false;
            this.showBackToDaily = true;
            this.hideLeftRightBtns();
        },
        showHideBackAndForwardTwelveBtnsForConsumptionChart() {
            if (!this.isDesktop || this.currentChart === chartHelper.ChartType.Monthly) {
                this.showBackAndForwardOneBtns();
                this.hideBackAndForwardTwelveBtns();
            } else {
                this.showBackAndForwardTwelveBtns();
            }
        },
        showDailyConsumptionChart(month, year) {
            this.currentChart = chartHelper.ChartType.Daily;
            this.getConsumptionData(this.currentConsumptionType, this.currentChart, this.servicePointId, this.year, this.month, this.day, this.isDesktop);
        },
        showHourlyConsumptionChart(month, year, day) {
            this.currentChart = chartHelper.ChartType.Hourly;
            this.getConsumptionData(this.currentConsumptionType, this.currentChart, this.servicePointId, this.year, this.month, this.day, this.isDesktop);
        },
        goToEnd() {
            if (!this.isDesktop) {
                if (this.currentChart === chartHelper.ChartType.Monthly) {
                    this.numberOfMonths = 4;
                }
            }

            var newMax = this.maximumAvailableDate;
            var newMin = chartHelper.addMonths(newMax, (this.numberOfMonths - 1) * -1);

            var chart = this.$refs.highchartsConsumptionChart.chart;
            chart.xAxis[0].setExtremes(newMin.getTime(), newMax.getTime());
        },
        translateText(textToBeTranslated) {
            var languages = this.$i18n.messages;
            var currentLanguage = this.$i18n.locale;
            
            // Check if current language is part of our set up
            if (currentLanguage in languages) {
                // Get all the messages for this language
                var currentLanguageMessages = languages[currentLanguage].message;
                if (currentLanguageMessages !== null && (textToBeTranslated !== "" || textToBeTranslated !== undefined)) {
                    var languageText = currentLanguageMessages[textToBeTranslated.replace(" ", "").toLowerCase()];
                    return languageText !== undefined ? languageText : textToBeTranslated;
                }
            }

            return textToBeTranslated;
        },
        hideMonthlyAndDailyBtns() {
            this.showBackToMonthly = false;
            this.showBackToDaily = false;
        },
        showError(message) {
            this.$toasted.global.error(message);
            this.$announcer.set(message);
        },
        showModal() {
            this.getDailyDollarGoal();            
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        getDailyDollarGoal() {
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Usage/GetDailyDollarGoalAmount"
            }).then(result => {
                var response = result.data;
                if (response !== 0) {
                    this.dailyGoal = response.toFixed(2);
                    this.isRemoveDailyGoalBtnDisabled = this.dailyGoal === 0;
                }
            }, error => {
                console.log(error);
            });
        },
        saveDailyDollarGoal(isRemove) {
            this.isModalVisible = false;
            // If user is trying to remove the daily goal that was set, we will reset its value back to zero
            this.dailyGoal = isRemove ? 0 : this.dailyGoal;
            var successMsg = isRemove ? 'Daily Goal has been removed.' : 'Daily Goal has been saved.';

            axios({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "Usage/UpdateDailyDollarGoal",
                data: {
                    dailyDollarGoal: this.dailyGoal
                }
            }).then(result => {
                var response = result.data;
                if (response) {
                    this.$toasted.global.success(successMsg);
                    this.$announcer.set(message);
                    this.isRemoveDailyGoalBtnDisabled = this.dailyGoal === 0;
                    this.reloadChartDataAfterSavingDailyDollarGoal();
                } else {
                    this.showError("Error updating Daily Goal, please try again.");
                }
            }, error => {
                this.showError("Error updating Daily Goal, please try again.");
            });
        },
        reloadChartDataAfterSavingDailyDollarGoal() {
            // Remove Daily Goal Plotline as the next call we make for fetching Dollar data will go ahead and re-plot the goal line
            this.removeDailyGoalPlotLine();
            this.getDollarData(this.currentConsumptionType, this.currentChart, this.servicePointId, this.year, this.month, this.day, this.numberOfMonths, this.isDesktop);
        }
    },
    computed: {
        displayDollarChart() {
            if (this.selectedChartDisplayType === chartHelper.ChartConsumptionType.Consumption && !this.showNoDataAvailableMessage) {
                return '';
            } else {
                return 'hide';
            }
        },
        isSaveDailyDollarGoalBtnDisabled() {
            return this.dailyGoal === 0 || this.dailyGoal < 0;
        },
        displayNoDataMessageForConsumption() {
            return this.showNoDataAvailableMessage && this.selectedChartDisplayType === chartHelper.ChartConsumptionType.Consumption;
        },
        displayChartFooterMessage() {
            return this.selectedChartDisplayType === chartHelper.ChartConsumptionType.Dollar || !this.showNoDataAvailableMessage;
        }
    },
    created() {
        window.addEventListener('resize', this.handleWindowResize);
        this.handleWindowResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleWindowResize);
    }
}
</script>

<style scoped>
    .chart-btn {
        color: #428BCA;
        background: #FFFFFF;
        padding-bottom: 0;
    }

        .chart-btn:hover {
            color: #FFFFFF;
            background: #428BCA;
        }

    .radio-custom label {
        display: inline-block;
        cursor: pointer;
        position: relative;
        padding-left: 25px;
        margin-right: 15px;
        font-size: 14px;
    }

    .radio-custom input[type=radio] {
        display: none;
    }

    .radio-custom label:before {
        content: "";
        display: inline-block;
        width: 18px;
        height: 18px;
        margin-right: 10px;
        position: absolute;
        left: 0;
        bottom: 1px;
        background-color: #fff;
        border-radius: 10px;
        border: 1px solid #c0c0c0;
    }

    .radio-custom input[type=radio]:checked + label:before {
        content: "\2022";
        color: #428BCA;
        font-size: 45px;
        text-align: center;
        line-height: 16px;
        border: 1px solid #c0c0c0;
    }

    .service-points-data {
        font-size: 13px;
    }

    .servicepoint-link {
        display: inline-block;
        vertical-align: middle;
        border-radius: 4px;
        padding: 8px 12px;
    }

    .servicepoint-link.selected {
        border: 1px solid #c0c0c0;
        box-shadow: none;
        text-decoration: none !important;
    }

    .servicepoint-link:hover, .servicepoint-link.selected:hover {
        color: #428BCA !important;
    }

    .padding-left-right-custom {
        padding-left: 10px;
        padding-right: 10px;
    }

    .alert-text {
        color: #333333;
        font-weight: bold;
    }

    .btn-icon {
        border: none;
        cursor: pointer;
        color: #428BCA !important;
        background: #ffffff !important;
        padding-top: 0;
    }

    .chart-export-btns {
        margin-top: 10px;
    }
</style>
